

import React, { memo, useState } from 'react';
import cryptoRandomString from 'crypto-random-string';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import {
  COPY_COOLDOWN,
  MIN_PASSWORD_STRENGTH_SCORE,
  DEFAULT_PASSWORD_LENGTH } from
'../constants/linkParams';

import { Button, Input, Text, Icon } from '../../../ui-kit';
import '../styles/_password-input.scss';






const LABEL = 'Set Password';

const CopyButton = ({
  password,
  onCopyPassword,
  isCopied




}) =>
<CopyToClipboard text={password} onCopy={onCopyPassword}>
      <Icon name={isCopied ? 'success' : 'duplicate'} size={15} />
    </CopyToClipboard>;


function PasswordInput({
  savedPassword = '',
  onPasswordUpdate
}) {
  const [password, setPassword] = useState(savedPassword);
  const [passwordScore, setPasswordScore] = useState(0);
  const [isCopied, setIsCopied] = useState(false);

  const arePasswords = savedPassword && password;
  const isPasswordSaved = arePasswords && savedPassword === password;
  const saveButtonText = isPasswordSaved ? 'Saved' : 'Save';

  const isValidPassword = () =>
  passwordScore >= MIN_PASSWORD_STRENGTH_SCORE && !isPasswordSaved;


  const handlePasswordUpdate = () => onPasswordUpdate({ savedPassword: password });

  const handleInputChange = async ({
    target: { value }
  }) => {
    const score = value ? value.length : 0;

    setPassword(value);
    setPasswordScore(score);
  };

  const generatePassword = async () => {
    const generatedPassword = cryptoRandomString({
      length: DEFAULT_PASSWORD_LENGTH
    });
    setPassword(generatedPassword);
    setPasswordScore(DEFAULT_PASSWORD_LENGTH);
  };

  const handleCopySuccess = () => {
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, COPY_COOLDOWN);
  };

  return (
    <div className="password-container">
      <div className="password-container__input">
        <Text link className="password-container__generate-password">
          <span
            role="button"
            tabIndex={0}
            onClick={generatePassword}
            onKeyDown={generatePassword}>

            Generate Password
          </span>
        </Text>
        <Input
          type="password"
          placeholder="Enter password"
          label={LABEL}
          labelProps={{ required: true }}
          defaultValue={password}
          value={password}
          suffixIcon={
          <CopyButton
            password={password}
            onCopyPassword={handleCopySuccess}
            isCopied={isCopied} />}


          onChange={handleInputChange}
          validate={isValidPassword}
          errorMessage="Please enter a valid password." />

        <Text caption className="password-caption">
          No minimum password requirements, but a strong password is
          recommended.
        </Text>
      </div>

      <Button
        className="password-container__save-button"
        type="SECONDARY"
        onClick={handlePasswordUpdate}
        disabled={!isValidPassword()}>

        {saveButtonText}
      </Button>
    </div>);

}

export default memo(PasswordInput);